export default __webpack_public_path__ + "static/media/about-us.5829fc94.jpg";